// eslint-disable-next-line
export const __DEV__ = process.env.NODE_ENV === 'development';
export const TOKEN_KEY = 'AUTH_TOKEN';
export const ROOT_STATE_STORAGE_KEY = 'root';
export const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '';

export { RoutePath } from './routes';
